module.exports = __webpack_public_path__ + "img/foodph.86d14ad8.png";